<template>
  <v-dialog v-model="openWindow">
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span>Update {{ product.nom }}</span>
          <v-btn icon @click.native="openWindow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text v-show="loading">
        <v-progress-linear
          indeterminate
          color="primary"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
      <v-card-text v-show="!loading">
        <v-row align="center">
          <v-col>
            <v-text-field
              v-model="product.nom"
              label="Nom"
              prepend-icon="local_offer"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col align-content-end>
            <v-switch label="Taxable" v-model="product.taxable"></v-switch>
          </v-col>
          <v-col>
            <j-date-picker
              v-model="product.date_retrait"
              label="Date de retrait"
            ></j-date-picker>
          </v-col>
          <v-btn icon @click="updateProduct"
            ><v-icon color="primary">check_circle_outline</v-icon></v-btn
          >
        </v-row>
        <v-divider class="my-1"></v-divider>
        <v-data-iterator
          :items="prices"
          hide-default-footer
          no-data-text=""
          no-results-text=""
        >
          <v-row align="center" slot="item" slot-scope="props">
            <v-col>
              <v-text-field
                type="number"
                v-model="props.item.taux"
                min="0"
                label="Prix"
              ></v-text-field>
            </v-col>
            <v-col>
              <j-date-picker
                v-model="props.item.date"
                label="Date"
              ></j-date-picker>
            </v-col>
            <v-btn
              :loading="props.item.loading"
              icon
              @click="updateExistingPrice(props.item.id_produit_prix)"
              ><v-icon>refresh</v-icon></v-btn
            >
          </v-row>
        </v-data-iterator>
        <v-divider class="my-1"></v-divider>
        <v-row align="center">
          <v-col>
            <j-date-picker
              v-model="newProductPrice.date"
              label="En vigueur le"
            ></j-date-picker>
          </v-col>
          <v-col>
            <v-text-field
              v-model="newProductPrice.price"
              label="Prix"
              min="0"
              type="number"
              prepend-icon="attach_money"
            >
            </v-text-field>
          </v-col>
          <v-btn icon @click="newPrice"
            ><v-icon color="primary">add_circle_outline</v-icon></v-btn
          >
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "CustomerAccountProductUpdateDialog",
  props: ["productId", "productName", "isOpen"],
  async created() {
    await this.getData();
  },
  computed: {
    openWindow: {
      get: function() {
        return this.isOpen;
      },
      set: function(value) {
        this.$emit("update:isOpen", value);
      }
    }
  },
  data() {
    return {
      loading: false,
      product: {},
      prices: [],
      newProductPrice: {
        menu: false,
        price: null,
        date: null
      }
    };
  },
  methods: {
    updateProduct: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/RU/" + this.productId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .put(url, this.product, config)
          .then(() => {
            this.$emit("update");
            this.openWindow = false;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    newPrice: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/price/by-product/" +
          this.productId +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        const data = {
          produit: this.productId,
          taux: this.newProductPrice.price,
          date: this.newProductPrice.date
        };
        axios
          .post(url, data, config)
          .then(() => {
            this.$emit("update");
            this.getProductPrice();
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    updateExistingPrice: function(idPrice) {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/price/rud/" + idPrice + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        const data = this.prices.find(p => p.id_produit_prix === idPrice);
        axios
          .put(url, data, config)
          .then(() => {
            this.$emit("update");
            this.getProductPrice();
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getData: async function() {
      this.loading = true;
      await Promise.all([this.getProduct(), this.getProductPrice()]);
      this.loading = false;
    },
    getProduct: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/RU/" + this.productId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.product = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getProductPrice: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/price/by-product/" +
          this.productId +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.prices = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    }
  }
};
</script>

<style scoped></style>
